import { useUpdateAgentStatus } from 'gcs-common/clients/api/entities/current-user/current-user-hooks';
import { ONLINE_STATUS } from 'gcs-common/helper/userStatusHelper';
import { getIsChatConnected } from 'gcs-common/slices/chatConnection/chatConnectionSelectors';
import { getCurrentUserId, getIsAgent } from 'gcs-common/slices/currentUser/currentUserSelectors';
import { getUserStatus } from 'gcs-common/slices/user/userSelectors';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { throttle } from 'throttle-debounce';

const IDLE_TIME = 15 * 60e3;

function IdleTimeManager() {
  const isAgent = useSelector(getIsAgent);
  const currentUserId = useSelector(getCurrentUserId);
  const currentStatus = useSelector(getUserStatus(currentUserId));
  const isChatConnected = useSelector(getIsChatConnected);

  const { updateAgentStatus } = useUpdateAgentStatus();

  const onIdleTime = async () => {
    const { type } = currentStatus;
    if (type === ONLINE_STATUS.ONLINE && isChatConnected) {
      updateAgentStatus({ statusType: ONLINE_STATUS.IDLE });
    }
  };

  useEffect(() => {
    if (!isAgent) {
      // only agent status is set to idle
      return undefined;
    }
    const events = ['mousemove', 'mousedown', 'click', 'scroll', 'keypress'];

    let idleTimeout = window.setTimeout(onIdleTime, IDLE_TIME);
    const onNonIdleAction = throttle(20 * 1e3, async () => {
      if (idleTimeout) window.clearTimeout(idleTimeout);
      idleTimeout = window.setTimeout(onIdleTime, IDLE_TIME);
    });
    for (const e of events) {
      window.addEventListener(e, onNonIdleAction);
    }
    return () => {
      for (const e of events) {
        window.removeEventListener(e, onNonIdleAction);
      }
    };
  }, [onIdleTime, isAgent]);

  return <div />;
}

export default IdleTimeManager;
